import React from 'react';
import styles from './VideoCloseBtn.scss';
import classNames from 'classnames/bind';
import videoClose from 'assets/images/shared/video-close.svg';

const cx = classNames.bind(styles);

const VideoCloseBtn = ({
  onStopVideo
}) => {
  return (
    <button className={cx('close-btn')} onClick={() => onStopVideo()}>
      <img src={videoClose} alt='close' />
    </button>
  );
};

export default VideoCloseBtn;


// WEBPACK FOOTER //
// ./src/app/components/molecules/VideoCloseBtn/VideoCloseBtn.js